(function() {
    /* globals angular */

    angular.module('ngmvac').filter('filtrosgral', FiltrosGral);

    function FiltrosGral() {

        var comparisonCriteria = {
            'one': ['1EST', 'H1_5'],
            'two': ['2EST', '2', 'H2_5'],
            'three': ['3EST', '3', 'H3_5'],
            'four': ['4EST', '4LUX', 'H4_5', 'SUP'],
            'five': ['5EST', '5LUX', 'H5_5'],
            'otros': /(^\d$)|(^\dEST$)|(^\dLUX$)|(^H\d_\d$)/
        };

        function determinaMinRatePublica(data) {
            for (var i = 0; i < data.length; i++) {
                if(angular.isDefined(data[i].packageGrouped)){
                    for (var iPG = 0; iPG < data[i].packageGrouped.length; iPG++) {
                        for (var iP = 0; iP < data[i].packageGrouped[iPG].length; iP++) {
                            if (iP === 0 && iPG === 0) {
                                data[i].minPackage      = data[i].packageGrouped[iPG][iP];
                                data[i].minRatePublica  = data[i].packageGrouped[iPG][iP].price;
                            } else if (data[i].minRatePublica > data[i].packageGrouped[iPG][iP].price) {
                                data[i].minPackage      = data[i].packageGrouped[iPG][iP];
                                data[i].minRatePublica  = data[i].packageGrouped[iPG][iP].price;
                            }
                        }
                    }
                }
            }

            return data;
        }

        return function(arr, stars, boards, name, zona, alojamiento) {
            // var applyFilter;
            var arrAux  = [];
            var num     = 0;
            var arrRes  = [];

            for (key in stars) {
                if (stars[key].selected == true) {
                    applyFilter = true;
                    num++;
                }
            }

            for (var iCat = 0; iCat < arr.length; iCat++) {
            	for (key in stars) {
                    comparisonCriteria[key]
                    if (stars[key].selected) {
                        if (key === 'otros') {
                            if (!comparisonCriteria['otros'].test(arr[iCat].categoryCode)) {
                                arrAux.push(arr[iCat]);
                            }
                        } else {
                            if (key !== 'reset') {
                            	for (var iCompCri = 0; iCompCri < comparisonCriteria[key].length; iCompCri++) {
                            		if (arr[iCat].categoryCode == comparisonCriteria[key][iCompCri]) {
                                        arrAux.push(arr[iCat]);
                                    }
                            	}
                            }
                        }
                    }
                }
            }

            if (num == 0) {
                arrAux = arr;
            }

            applyFilter = false;
            var num2 = 0;

            angular.forEach(boards, function(board) {
                if (board.checked == true) {
                    applyFilter = true;
                    num2++;
                }
            });

            angular.forEach(arrAux, function(hotel, index) {
                var clHotel = {};

                for (property in hotel) {
                    clHotel[property] = hotel[property];
                }
                if( angular.isDefined(hotel.packageGrouped) ){
                    clHotel.packageGrouped = [];
                    angular.forEach(hotel.packageGrouped, function(group, indexGroup) {
                        angular.forEach(boards, function(board, indexBoard) {
                            if (board.boardCode == group[0].boardCode) {
                                if (board.checked) {
                                    clHotel.packageGrouped.push(group);
                                    clHotel.minPackage = group[0];
                                }
                            }
                        });
                    });
                    if (clHotel.packageGrouped.length > 0) {
                        arrRes.push(clHotel);
                    }
                }
            });

            if (num2 == 0) {
                arrRes = arrAux;
            }

            if (name != "") {
                var hotelArray = [];
                var arrAux = [];
                angular.forEach(arrRes, function(hotel) {
                    hotelArray.push(hotel);
                });
                var nombre = "";
                for (var i = 0; i < hotelArray.length; i++) {
                    nombre = hotelArray[i].name;
                    if (nombre.toLowerCase().indexOf(name.toLowerCase()) != -1) {
                        arrAux.push(hotelArray[i]);
                    }
                }
            } else {
                arrAux = arrRes;
            }

            arrAux2 = arrAux;

            if (zona == 'Todas') {
                hotelArray2 = arrAux2;
            } else {
                var hotelArray1 = [];
                var hotelArray2 = [];
                angular.forEach(arrAux2, function(hotel) {
                    hotelArray1.push(hotel);
                });
                for (var i = 0; i < hotelArray1.length; i++) {
                    if (hotelArray1[i].zoneName == zona) {
                        hotelArray2.push(hotelArray1[i]);
                    }
                }
            }
            

            var hotelArray3 = [];

            if (alojamiento == 'Apartamento') {
                var apart = ['3LL', '5LL', 'STD', 'AT1', '2LL', 'AT2', 'AT3', '1LL', '4LL'];
            } else if (alojamiento == 'Aparthotel') {
                var apart = ['APTH3', 'APTH4', 'APTH5', 'APTH', 'APTH2'];
            } else if (alojamiento == 'Camping') {
                var apart = ['CAMP2', 'CAMP1'];
            } else if (alojamiento == 'Villa') {
                var apart = ['VTV', 'VILLA'];
            } else if (alojamiento == 'Albergue') {
                var apart = ['HS4', 'HS', 'HS2', 'HS5', 'HS3', 'PENSI', 'RESID', 'POUSA', 'LODGE', 'ALBER', 'CHUES'];
            } else if (alojamiento == 'Sin Categoría') {
                var apart = ['PENDI', 'SPC'];
            } else if (alojamiento == 'Resort') {
                var apart = ['RSORT'];
            } else if (alojamiento == 'Agroturismo') {
                var apart = ['HRS', 'HR5', 'HSR1', 'HR4', 'HR2', 'HSR2', 'HR3', ];
            } else if (alojamiento == 'Hotel') {
                var apart = ['H2S', 'H1_5', 'BOU', 'BB5', 'SUP', 'H2_5', 'H3S', 'H3_5', 'H4_5', 'H5_5', 'HIST', 'BB', 'MINI', 'BB4', 'BB3', '4EST', '4LUX', '5EST', '5LUX', '3EST', '3', '2EST', '2', '1EST'];
            } else if (alojamiento == 'Todas') {
                hotelArray3 = hotelArray2;
            }

            if (alojamiento != 'Todas') {
                for (var i = 0; i < hotelArray2.length; i++) {
                    for (var z = 0; z < apart.length; z++) {
                        if (apart[z] == hotelArray2[i].categoryCode) {
                            hotelArray3.push(hotelArray2[i]);
                        }
                    }
                }
            }

            return hotelArray3;

        }
    }
})();
